<template>
    <form style="position: relative">
      <div style="position: absolute; top: 10px; right: 10px;">
        <CopyBlock :sharedData="sharedData" />
      </div>
      <h2>Dynamic Block</h2>
      
      <!-- Reiter: Main -->
      <div class="accordion-item">
        <div class="accordion-header" @click="toggleSection('main')">
          <span>Main</span>
          <span class="material-symbols-outlined">
            {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </span>
        </div>
        <div v-show="isSectionActive('main')" class="accordion-content">
          <div class="divider">
            <label for="dynamicXPath">XPath:</label>
            <input
              id="dynamicXPath"
              type="text"
              v-model="sharedData.data.props.dynamicXPath"
              placeholder="path/to/node"
            />
          </div>
        </div>
      </div>
  
      <!-- Reiter: Content -->
      <div class="accordion-item">
        <div class="accordion-header" @click="toggleSection('content')">
          <span>Content</span>
          <span class="material-symbols-outlined">
            {{ isSectionActive('content') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </span>
        </div>
        <div v-show="isSectionActive('content')" class="accordion-content">
          <!-- Editor für Header -->
          <div class="editor-section">
            <h3>Header</h3>
            <div class="editor">
              <div class="toolbar">
                <!-- Optionale Toolbar-Buttons -->
              </div>
              <editor-content :editor="headerEditor" class="editor-content" />
            </div>
          </div>
          <!-- Editor für Dynamic/Children (wiederholender Mittelteil) -->
          <div class="editor-section">
            <h3>Dynamic Content</h3>
            <div class="editor">
              <div class="toolbar">
                <!-- Optionale Toolbar-Buttons -->
              </div>
              <editor-content :editor="childrenEditor" class="editor-content" />
            </div>
          </div>
          <!-- Editor für Footer -->
          <div class="editor-section">
            <h3>Footer</h3>
            <div class="editor">
              <div class="toolbar">
                <!-- Optionale Toolbar-Buttons -->
              </div>
              <editor-content :editor="footerEditor" class="editor-content" />
            </div>
          </div>
        </div>
      </div>
  
      <!-- Reiter: Style -->
      <div class="accordion-item">
        <div class="accordion-header" @click="toggleSection('style')">
          <span>Style</span>
          <span class="material-symbols-outlined">
            {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </span>
        </div>
        <div v-show="isSectionActive('style')" class="accordion-content">
          <AlignmentProp :sharedData="sharedData" />
          <PaddingProp :sharedData="sharedData" />
        </div>
      </div>
    </form>
  </template>
  
  <script>
  import { EditorContent, Editor } from '@tiptap/vue-3'
  import StarterKit from '@tiptap/starter-kit'
  import Bold from '@tiptap/extension-bold'
  import Italic from '@tiptap/extension-italic'
  import Underline from '@tiptap/extension-underline'
  import Strike from '@tiptap/extension-strike'
  import Link from '@tiptap/extension-link'
  import HardBreak from '@tiptap/extension-hard-break'
  import Paragraph from '@tiptap/extension-paragraph'
  import Text from '@tiptap/extension-text'
  import Table from '@tiptap/extension-table'
  import TableRow from '@tiptap/extension-table-row'
  import TableCell from '@tiptap/extension-table-cell'
  import TableHeader from '@tiptap/extension-table-header'
  import Document from '@tiptap/extension-document'
import Gapcursor from '@tiptap/extension-gapcursor'

  import AlignmentProp from './AddProps/AlignmentProp.vue'
  import PaddingProp from './AddProps/PaddingProp.vue'
import CopyBlock from './AddProps/CopyBlock.vue'

const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      // extend the existing attributes …
      ...this.parent?.(),

      // and add a new one …
      backgroundColor: {
        default: null,
        parseHTML: element => element.getAttribute('data-background-color'),
        renderHTML: attributes => {
          return {
            'data-background-color': attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          }
        },
      },
      style: {
        default: 'border: 1px solid #ccc; border-collapse: collapse;',
        parseHTML: element => element.getAttribute('style'),
        renderHTML: attributes => {
          return {
            style: attributes.style || 'border: 1px solid #ccc; border-collapse: collapse;',
          }
        },
      },
    }
  },
})

  export default {
    name: 'AddDynamic',
    components: {
      EditorContent,
      AlignmentProp,
      PaddingProp,
      CopyBlock
    },
    props: ['sharedData'],
    data() {
      // Falls sharedData.data.props noch nicht existiert, initialisieren wir es.
      if (!this.sharedData.data.props) {
        this.sharedData.data.props = {}
      }
      // Setze alle Felder initial auf einen leeren String, sodass der insertTable-Befehl greifen kann.
      if (!this.sharedData.data.props.header) {
        this.sharedData.data.props.header = ''
      }
      if (!this.sharedData.data.props.children) {
        this.sharedData.data.props.children = ''
      }
      if (!this.sharedData.data.props.footer) {
        this.sharedData.data.props.footer = ''
      }
      return {
        headerEditor: null,
        childrenEditor: null,
        footerEditor: null,
        activeSections: ['main']
      }
    },
    mounted() {
      // Header Editor
      this.headerEditor = new Editor({
        extensions: [
          StarterKit,
          Bold,
          Italic,
          Underline,
          Strike,
          Link,
          HardBreak,
          Paragraph,
          Text,
          Table.configure({ resizable: true }),
          TableRow,
          TableHeader,
          TableCell,
        ],
        content: this.sharedData.data.props.header,
        editorProps: {
          attributes: {
            style: 'min-height: 100px; border: 1px solid #ccc; border-radius: 4px; padding: 5px; font-size: 14px;'
          }
        },
        onCreate: ({ editor }) => {
          // setTimeout, damit der Editor vollständig initialisiert ist
          setTimeout(() => {
            // Wenn der Editor nur ein leeres <p></p> enthält, dann Tabelle einfügen
            if (editor.getHTML().trim() === '<p></p>') {
              editor.commands.insertTable({ rows: 1, cols: 3, withHeaderRow: true });
            }
          }, 0);
        },
        onUpdate: ({ editor }) => {
          this.sharedData.data.props.header = editor.getHTML();
        },
      });
  
      // Children Editor
      this.childrenEditor = new Editor({
        extensions: [
          StarterKit,
          Bold,
          Italic,
          Underline,
          Strike,
          Link,
          HardBreak,
          Paragraph,
          Text,
          Table.configure({ resizable: true }),
          TableRow,
          TableHeader,
          TableCell,
        ],
        content: this.sharedData.data.props.children,
        editorProps: {
          attributes: {
            style: 'min-height: 100px; border: 1px solid #ccc; border-radius: 4px; padding: 5px; font-size: 14px;'
          }
        },
        onCreate: ({ editor }) => {
          setTimeout(() => {
            if (editor.getHTML().trim() === '<p></p>') {
              editor.commands.insertTable({ rows: 2, cols: 3, withHeaderRow: false });
            }
          }, 0);
        },
        onUpdate: ({ editor }) => {
          this.sharedData.data.props.children = editor.getHTML();
        },
      });
  
      // Footer Editor
      this.footerEditor = new Editor({
        extensions: [
          StarterKit,
          Bold,
          Italic,
          Underline,
          Strike,
          Link,
          HardBreak,
          Paragraph,
          Text,
          Document,
          Gapcursor,
          Table.configure({ resizable: true }),
          TableRow,
          TableHeader,
          CustomTableCell
        ],
        content: this.sharedData.data.props.footer,
      editorProps: {
          attributes: {
            style: 'min-height: 100px; border: 1px solid #ccc; border-radius: 4px; padding: 5px; font-size: 14px;'
          }
        },
        onCreate: ({ editor }) => {
          setTimeout(() => {
            if (editor.getHTML().trim() === '<p></p>') {
              editor.commands.insertTable({ rows: 1, cols: 3, withHeaderRow: false });
            }
          }, 0);
        },
        onUpdate: ({ editor }) => {
          this.sharedData.data.props.footer = editor.getHTML();
        },
      });
    },
    beforeUnmount() {
      if (this.headerEditor) this.headerEditor.destroy();
      if (this.childrenEditor) this.childrenEditor.destroy();
      if (this.footerEditor) this.footerEditor.destroy();
    },
    methods: {
      toggleSection(section) {
        if (this.activeSections.includes(section)) {
          this.activeSections = this.activeSections.filter(s => s !== section);
        } else {
          this.activeSections.push(section);
        }
      },
      isSectionActive(section) {
        return this.activeSections.includes(section);
      },
    },
  };
  </script>
  <style lang="scss">
  /* Basic editor styles */
  .tiptap {
    :first-child {
      margin-top: 0;
    }
  
    /* Table-specific styling */
    table {
      border-collapse: collapse;
      margin: 0;
      overflow: hidden;
      table-layout: fixed;
      width: 100%;
  
      td,
      th {
        border: 1px solid black;
        box-sizing: border-box;
        min-width: 1em;
        padding: 6px 8px;
        position: relative;
        vertical-align: top;
  
        > * {
          margin-bottom: 0;
        }
      }
  
      th {
        text-align: left;
        color: green
      }
  
      .selectedCell:after {
        background: var(--gray-2);
        content: "";
        left: 0; right: 0; top: 0; bottom: 0;
        pointer-events: none;
        position: absolute;
        z-index: 2;
      }
  
      .column-resize-handle {
        background-color: var(--purple);
        bottom: -2px;
        pointer-events: none;
        position: absolute;
        right: -2px;
        top: 0;
        width: 4px;
      }
    }
  
    .tableWrapper {
      margin: 1.5rem 0;
      overflow-x: auto;
    }
  
    &.resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }
  }
  </style>

  
  